export const OffcanvasDirectionsSubTitle = [
  {
    text: "Use ",
    code: "Offcanvas-* ",
  },
  {
    text: "[top/end/bottom/start] class allows you to modify the offcanvas direction.",
  },
];

export const OffcanvasVariationsSubTitle = [
  {
    text: "Use ",
    code: "data-bs-scroll ",
  },
  {
    text: "attribute to enable ",
    code: "<body> ",
  },
  {
    text: "scrolling class and clicking outside of the offcanvas will not cause it to close if the backdrop is static.",
  }
];
